'use strict';

var Mime = require('./Mime');
module.exports = new Mime(require('./types/standard'), require('./types/other'));



//////////////////
// WEBPACK FOOTER
// ./node_modules/google-auth-library/node_modules/mime/index.js
// module id = 9J2+
// module chunks = 0